import React, { useState, useRef, useEffect } from 'react';
import { useTheme, ThemeType } from '../contexts/ThemeContext';

const ThemeSwitcher: React.FC = () => {
  const { theme, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // 主题选项
  const themes: { id: ThemeType; name: string; icon: string }[] = [
    { id: 'default', name: '默认', icon: '🌙' },
    { id: 'light', name: '浅色', icon: '☀️' },
    { id: 'vibrant', name: '撞色', icon: '🎨' },
    { id: 'gradient', name: '渐变', icon: '🌈' }
  ];

  // 点击外部关闭下拉菜单
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // 切换主题
  const handleThemeChange = (newTheme: ThemeType) => {
    setTheme(newTheme);
    setIsOpen(false);
  };

  // 获取当前主题图标
  const getCurrentThemeIcon = () => {
    const currentTheme = themes.find(t => t.id === theme);
    return currentTheme ? currentTheme.icon : '🌙';
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`btn py-1 px-3 text-sm bg-dark-700 text-dark-200 hover:bg-dark-600 transition-all duration-200 flex items-center`}
        aria-label="切换主题"
      >
        <span className="mr-1">{getCurrentThemeIcon()}</span>
        主题
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-1 w-36 bg-dark-700 border border-dark-600 rounded-lg shadow-lg z-20 overflow-hidden">
          {themes.map((themeOption) => (
            <button
              key={themeOption.id}
              onClick={() => handleThemeChange(themeOption.id)}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-dark-600 transition-colors duration-150 flex items-center ${
                theme === themeOption.id ? 'bg-primary-600 text-white' : 'text-dark-200'
              }`}
            >
              <span className="mr-2">{themeOption.icon}</span>
              {themeOption.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThemeSwitcher;
